/**
 * Actual category icon assets sourced from the reference website
 * (bdvegas.online / img.b100vg.com theme-icon set).
 *
 * Source paths discovered via DOM inspection of:
 *   .nav-category .btn .item-icon { background-image: url(...) }
 *
 * Original remote files (copied locally — no runtime hotlink):
 *   https://img.b100vg.com/bvg/h5/assets/images/icon-set/theme-icon/icon-hotgame.png
 *   https://img.b100vg.com/bvg/h5/assets/images/icon-set/theme-icon/icon-sport.png
 *   https://img.b100vg.com/bvg/h5/assets/images/icon-set/theme-icon/icon-casino.png
 *   https://img.b100vg.com/bvg/h5/assets/images/icon-set/theme-icon/icon-slot.png
 *   https://img.b100vg.com/bvg/h5/assets/images/icon-set/theme-icon/icon-crash.png
 *   https://img.b100vg.com/bvg/h5/assets/images/icon-set/theme-icon/icon-table.png
 *   https://img.b100vg.com/bvg/h5/assets/images/icon-set/theme-icon/icon-fish.png
 *   https://img.b100vg.com/bvg/h5/assets/images/icon-set/theme-icon/icon-arcade.png
 *   https://img.b100vg.com/bvg/h5/assets/images/icon-set/theme-icon/icon-lottery.png
 */
import hot from './hot.png';
import sports from './sports.png';
import casino from './casino.png';
import slots from './slots.png';
import crash from './crash.png';
import table from './table.png';
import fishing from './fishing.png';
import arcade from './arcade.png';
import lottery from './lottery.png';

export const CATEGORY_ICON_SRC = {
  hot,
  sports,
  casino,
  slots,
  crash,
  table,
  fishing,
  arcade,
  lottery,
};

export const CATEGORY_ICON_KEYS = Object.keys(CATEGORY_ICON_SRC);
